import React from "react";
import PropTypes from "prop-types";

import { IconWrapper } from "./IconWrappers";

const MenuIcon = ({ color, onClick }) => (
  <IconWrapper onClick={onClick}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" x="0px" y="0px">
      <g>
        <g transform="translate(-69.000000, -228.000000)">
          <g transform="translate(69.000000, 230.000000)">
            <path
              fill={color}
              d="M0,1 C0,0.44771525 0.444946289,0 0.993397683,0 L17.0066023,0 C17.5552407,0 18,0.443864822 18,1 C18,1.55228475 17.5550537,2 17.0066023,2 L0.993397683,2 C0.444759292,2 0,1.55613518 0,1 Z M0,7 C0,6.44771525 0.444946289,6 0.993397683,6 L17.0066023,6 C17.5552407,6 18,6.44386482 18,7 C18,7.55228475 17.5550537,8 17.0066023,8 L0.993397683,8 C0.444759292,8 0,7.55613518 0,7 Z M0,13 C0,12.4477153 0.444946289,12 0.993397683,12 L17.0066023,12 C17.5552407,12 18,12.4438648 18,13 C18,13.5522847 17.5550537,14 17.0066023,14 L0.993397683,14 C0.444759292,14 0,13.5561352 0,13 Z"
            />
          </g>
        </g>
      </g>
    </svg>
  </IconWrapper>
);

MenuIcon.propTypes = {
  color: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
};

export default MenuIcon;



// WEBPACK FOOTER //
// ./src/assets/icons/MenuIcon.js